import { Helmet } from "react-helmet-async";
import { useEffect, useMemo } from "react";
import { trackEvent } from "../utils/amplitude";

interface PageHeadProps {
  title: string;
  description?: string;
  additionalProps?: Record<string, string | number | boolean | null | undefined>;
}

export const PageHead = ({ title, description, additionalProps }: PageHeadProps) => {
  const fullTitle = `AchieveOS - ${title}`;

  const memoizedProps = useMemo(() => additionalProps || {}, [additionalProps]);

  useEffect(() => {
    // Small delay to ensure Helmet has updated the DOM
    const timer = setTimeout(() => {
      const currentTitle = document.title;
      trackEvent("[Amplitude] Page Viewed", {
        "[Amplitude] Page Title": currentTitle,
        "[Amplitude] Page URL": window.location.href,
        "[Amplitude] Page Path": window.location.pathname,
        "[Amplitude] Page Domain": window.location.hostname,
        ...memoizedProps,
      });
    }, 200);

    return () => clearTimeout(timer);
  }, [title, memoizedProps]);

  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
    </Helmet>
  );
};
